import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const Epi = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="UTILIZAÇÃO DO EPI DURANTE A ASSISTÊNCIA" />
                    <div style={{ textAlign: "left" }}>
                        <HeaderVerde texto="PROFISSIONAL" />
                        <Select valor={props.valor} label="Máscara N95" nome="n95" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select valor={props.valor} label="Avental Descartável" nome="avental" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select valor={props.valor} label="Touca de Proteção" nome="touca" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select valor={props.valor} label="Propé" nome="prope" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select valor={props.valor} label="Protetor Facial/Óculos de Proteção" nome="oculos" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select valor={props.valor} label="Máscara Cirurgica" nome="mascaraCirurgica" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>
                    <div style={{ textAlign: "left" }}>
                        <HeaderVerde texto="PACIENTE" />
                        <Select valor={props.valor} label="Máscara" nome="n95" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                       
                    </div>
                    <HeaderVerde texto="LEGALIDADE" />
                    <div style={{ textAlign: "left" }}>
                        <Select valor={props.valor} label="Conformidade com a Resolução COFFITO Nº 517/2020"
                            nome="conformidade517" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthDiv="60vw" widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select valor={props.valor} label="Utilização de EPI por parte do profissional em conformidade com a nota técnica 
                    ANVISA 04/2020 e nota técnica ANVISA 07/2020"
                            nome="conformidade517" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthDiv="60vw" widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>
                </Caixa>
            )
        }
        return partes
    }
}

export default Epi